<template>
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
        d="M7.6 2.2C7.45143 2.08857 7.27477 2.02072 7.08981 2.00404C6.90484 1.98736 6.71889 2.02252 6.55279 2.10557C6.38668 2.18863 6.24698 2.31629 6.14935 2.47427C6.05171 2.63225 6 2.81429 6 3V21C6 21.1857 6.05171 21.3678 6.14935 21.5257C6.24698 21.6837 6.38668 21.8114 6.55279 21.8944C6.71889 21.9775 6.90484 22.0126 7.08981 21.996C7.27477 21.9793 7.45143 21.9114 7.6 21.8L19.6 12.8C19.7242 12.7069 19.825 12.5861 19.8944 12.4472C19.9639 12.3084 20 12.1552 20 12C20 11.8448 19.9639 11.6916 19.8944 11.5528C19.825 11.4139 19.7242 11.2931 19.6 11.2L7.6 2.2Z"
        fill="white"/>
  </svg>
</template>
<script>
export default {
  name: 'PlayIcon'
}
</script>